export class FinancialStatusReport {
  marinaId: number;
  starDate: Date;
  endDate: Date;
  grupos: any[];
}
